"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationSkeleton = exports.CarouselSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const PaginationSkeleton = exports.PaginationSkeleton = (0, _mui.styled)(_presentationComponents.PaginationSkeleton)(({
  theme
}) => ({
  margin: 'auto',
  maxWidth: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 360
  }
}));
const CarouselSkeleton = exports.CarouselSkeleton = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(2),
  gridTemplateColumns: `repeat(6, ${_presentationComponents.EDITORIAL_CAROUSEL_SLIDE_MOBILE_MIN_WIDTH}px)`,
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(10),
    gridTemplateColumns: `repeat(6, ${_presentationComponents.ARTICLE_BOX_DESKTOP_WIDTH}px)`
  }
}));
